import React from 'react'
import { Dispatch } from 'redux'
import { CaptionLight, H3, P } from '../../components/StyledText'
import { IMediaType } from '../../types/mediaType'
import { StyledAllTypesTable } from './styled'
import { push } from '../../actions/router'

export interface IAllMediaTypesTab {
  mediaTypesList: IMediaType[]
  dispatch: Dispatch
}

export const AllMediaTypesTab = ({
  mediaTypesList = [],
  dispatch,
}: IAllMediaTypesTab) => (
  <>
    <StyledAllTypesTable>
      <thead>
        <tr>
          <th>
            <CaptionLight>Title</CaptionLight>
          </th>
          <th>
            <CaptionLight>Content Type</CaptionLight>
          </th>
          <th>
            <CaptionLight>Extension</CaptionLight>
          </th>
          <th>
            <CaptionLight>Mime Type</CaptionLight>
          </th>
        </tr>
      </thead>
      <tbody>
        {mediaTypesList.map((mediaType) => (
          <tr
            key={mediaType.extension}
            onClick={() => {
              dispatch(
                push(
                  `/settings/media-types/${encodeURIComponent(
                    mediaType.extension
                  )}?tab=details`
                )
              )
            }}
          >
            <td>
              <H3>{mediaType.title}</H3>
            </td>
            <td>
              <P>{mediaType.mediaContentType}</P>
            </td>
            <td>
              <P>{mediaType.extension}</P>
            </td>
            <td>
              <P>{mediaType.mimeType}</P>
            </td>
          </tr>
        ))}
      </tbody>
    </StyledAllTypesTable>
  </>
)
